import { Component, Input, OnInit } from '@angular/core';
import { PartnerQuery, Partner, PartnerService, PartnerPendingService, PartnerPending, PartnerPendingQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-partner-list',
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss'],
})
export class PartnerListComponent implements OnInit {
  constructor(
    private pendingQuery: PartnerPendingQuery,
    private partnerQuery: PartnerQuery,
    private partnerService: PartnerService,
    private pendingService: PartnerPendingService
  ) { }
  @Input() partnerLimit: number;
  approvedPartners$: Observable<Partner[]>;
  pendingPartners$: Observable<PartnerPending[]>;
  Populations = Populations
  ngOnInit() {
    this.approvedPartners$ = this.partnerQuery.selectAll();
    this.pendingPartners$ = this.pendingQuery.selectAll();
  }

  delete(id: number) {
    this.partnerService.remove(id).toPromise();
  }

  deletePending(ticketKey: string) {
    this.pendingService.remove(ticketKey).toPromise();
  }
}
